import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription, debounceTime, firstValueFrom, of } from 'rxjs';
import { UserService } from '../../../../../../core/services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DynamicModalService } from '../../../../../../core/services/dynamic-modal.service';
import {
  selectAuth,
  selectUser,
} from '../../../../../../core/state/auth/auth.selector';
import { Store } from '@ngrx/store';
import { CodeBonusService } from '../../../../../../core/services/code-bonus.service';
import { PlayerService } from '../../../../../../core/services/player.service';
import { CODE_BONUS_CONSTANS } from '../../../../../../core/constants/constants';

@Component({
  selector: 'app-create-forms-bc-free',
  templateUrl: './create-forms-bc-free.component.html',
  styleUrls: ['./create-forms-bc-free.component.scss'],
})
export class CreateFormsBcFreeComponent implements OnInit, OnDestroy {
  public allTypeBonusData: any[] = [];
  public optionsAgents$: any;
  public optionsPlayers$: any;
  public id_country!: any;
  public agente = CODE_BONUS_CONSTANS.AGENTE;
  public currentPageAgents = 1;
  public currentPagePlayers = 1;
  public allPlayersData: any[] = [];
  public allAgentsData: any[] = [];
  public isAgent = true;
  public pageSize = 10;
  private bonusSubject: Subject<string> = new Subject<string>();
  public criteria: any;
  public bonusForm!: FormGroup;
  public isLoadingButton = false;
  public isLoadingBonusTypes = false;
  public profile$ = this.store.select(selectAuth);
  public idRol: number | null = null;
  private selectedOption: any = null;
  private id_agente: any = null;
  private currentUserId: number | null = null;
  public bonusBalanceData: number = 0;
  private subscriptions: Subscription[] = [];
  public bonoIlimitado$ = this.store.select(selectUser);

  private buildBonusTypeLabel(item: any): string {
    const baseLabel = item.nombre || item.detalle;
    if (this.idRol === this.agente) {
      return baseLabel;
    }

    return `${baseLabel} - ${item.porcentaje}%`;
  }

  constructor(
    private _userService: UserService,
    private bonusCodeService: CodeBonusService,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private _toastrSvc: ToastrService,
    private dynamicModal: DynamicModalService,
    private store: Store,
    private cd: ChangeDetectorRef,
    private _playerService: PlayerService
  ) {
    this.initForm();
    this.bonusSubject.pipe(debounceTime(400)).subscribe((term: any) => {
      this.allAgentsData = [];
      this.allPlayersData = [];
      if (this.isAgent) {
        this.loadAgents(term);
      } else {
        this.loadPlayers(term);
      }
    });
  }

  async ngOnInit(): Promise<void> {
    const data = this.dynamicModal.getModalData();
    const profileData: any = await firstValueFrom(this.bonoIlimitado$);
    this.id_country = this.dynamicModal.getModalData();
    this.currentUserId = profileData?.idusuario ?? null;
    this.cd.detectChanges();
    this.loadPlayers();

    if (data?.id_agente) {
      this.idRol = data.idRol;
      this.id_agente = data.id_agente;
      this.id_country = data.id_country;
    } else {
      this.idRol = profileData.id_rol;
      this.id_agente = profileData.idusuario;
    }

    this.loadAllTypeBonusUnrestricted();

    if (this.idRol === this.agente) {
      this.bonusForm.patchValue({ id_agente: this.id_agente });
      this.bonusForm.get('id_agente')?.clearValidators();
      this.getBalanceBonus(this.id_agente);
    } else {
      this.bonusForm.get('id_agente')?.setValidators(Validators.required);
      this.loadAgents();
      this.subscribeToAgentChanges();
    }

    this.bonusForm.get('id_agente')?.updateValueAndValidity();
  }

  loadAgents(searchTerm?: string) {
    this._userService
      .getAgents(
        this.id_country,
        this.currentPageAgents,
        this.pageSize,
        searchTerm
      )
      .subscribe((response) => {
        const transformedData = response.data.map(
          (item: { usuario: any; idusuario: any }) => ({
            label: item.usuario,
            value: item.idusuario,
          })
        );
        this.optionsAgents$ = of(transformedData);
        this.allAgentsData = [...this.allAgentsData, ...transformedData];
      });
  }

  loadPlayers(searchTerm?: string) {
    this._playerService
      .getPlayers(
        this.id_country,
        this.currentPagePlayers,
        this.pageSize,
        searchTerm
      )
      .subscribe((response) => {
        const transformedData = response.data.map((item: any) => ({
          label: item.usuario_jugador,
          value: item.id_jugador,
          whiteList: item.jugador_white_list?.lista_negra,
          id_usuario: item.id_usuario,
        }));
        this.optionsPlayers$ = of(transformedData);
        this.allPlayersData = [...this.allPlayersData, ...transformedData];
      });
  }

  loadAllTypeBonusUnrestricted() {
    this.isLoadingBonusTypes = true;

    const subscription = this.bonusCodeService
      .getAllTypeBonusUnrestricted()
      .subscribe({
        next: (response) => {
          const filteredData = (response.data || []).filter(
            (item: any) => item.activar === 1
          );

          this.allTypeBonusData = filteredData.map((item: any) => ({
            label: this.buildBonusTypeLabel(item),
            value: item.idbono_tipos,
            porcentaje: item.porcentaje,
            detalle: item.detalle,
            nombre: item.nombre,
          }));

          if (this.allTypeBonusData.length > 0) {
            this.bonusForm.patchValue({
              tipo_bono: null,
              detalle_tipo_bono: null,
            });
            this.selectedOption = null;
          }

          this.isLoadingBonusTypes = false;
        },
        error: () => {
          this.isLoadingBonusTypes = false;
          this._toastrSvc.error(
            'No se pudieron cargar todos los tipos de bono',
            ''
          );
        },
      });

    this.subscriptions.push(subscription);
  }

  subscribeToAgentChanges() {
    const subscription = this.bonusForm
      .get('id_agente')
      ?.valueChanges.subscribe((agentId) => {
        this.id_agente = agentId;
        if (!agentId) {
          this.bonusBalanceData = 0;
          return;
        }
        this.getBalanceBonus(agentId);
      });

    if (subscription) {
      this.subscriptions.push(subscription);
    }
  }

  private syncSelectedOptionFromControl() {
    const selectedBonusTypeId = Number(this.bonusForm.get('tipo_bono')?.value);

    if (!selectedBonusTypeId) {
      this.selectedOption = null;
      return;
    }

    this.selectedOption =
      this.allTypeBonusData.find(
        (option) => Number(option.value) === selectedBonusTypeId
      ) ?? null;
  }

  onSelectChange(selectedValue: any) {
    const bonusTypeId = Number(
      selectedValue?.value ??
        selectedValue ??
        this.bonusForm.get('tipo_bono')?.value
    );

    if (!bonusTypeId) {
      this.selectedOption = null;
      this.bonusForm.patchValue({ monto: null });
      return;
    }

    this.selectedOption = this.allTypeBonusData.find(
      (option) => Number(option.value) === bonusTypeId
    );
    if (this.selectedOption) {
      this.calculateResultAmountBonus();
    }
  }

  onRechargeAmountChange() {
    this.calculateResultAmountBonus();
  }

  calculateResultAmountBonus() {
    const rechargeAmount = this.bonusForm.get('monto_recarga')?.value;
    const fractions = this.bonusForm.get('fracciones')?.value || 1;

    if (!this.selectedOption) {
      this.syncSelectedOptionFromControl();
    }

    if (this.selectedOption && rechargeAmount) {
      const multiplyingPercentage =
        parseFloat(this.selectedOption.porcentaje) * parseFloat(rechargeAmount);
      const amountPerBonus = multiplyingPercentage / parseFloat(fractions);
      this.bonusForm.patchValue({ monto: amountPerBonus.toFixed(2) });
    }
  }

  onScrollToEnd() {
    if (this.isAgent) {
      this.currentPageAgents++;
      this.loadAgents(this.criteria);
    } else {
      this.currentPagePlayers++;
      this.loadPlayers(this.criteria);
    }
  }

  onSearch(term: string) {
    this.criteria = term;
    if (this.isAgent) {
      this.allAgentsData = [];
      this.currentPageAgents = 1;
      this.bonusSubject.next(term);
    } else {
      this.allPlayersData = [];
      this.currentPagePlayers = 1;
      this.bonusSubject.next(term);
    }
  }

  closeModal() {
    this.activeModal.close();
    this.bonusForm.reset();
  }

  initForm(): void {
    this.bonusForm = this.fb.group({
      monto_recarga: [null],
      monto: [null, Validators.min(0.1)],
      tipo_bono: [null, Validators.required],
      id_agente: [null],
      comentario: [null],
      fracciones: [1],
      id_usu_creabono: [null],
      detalle_tipo_bono: [null],
      id_pais: [null],
    });
  }

  onKeyPressSpecial(event: KeyboardEvent) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  isFormValid(): boolean {
    return (
      this.bonusForm.valid &&
      this.bonusForm.get('fracciones')?.value > 0 &&
      !!this.bonusForm.get('id_agente')?.value
    );
  }

  getBalanceBonus(agentId?: number): void {
    const targetAgentId = agentId ?? this.id_agente;

    if (!targetAgentId) {
      this.bonusBalanceData = 0;
      return;
    }

    const subscription = this.bonusCodeService
      .getAgentBalance({ agentId: targetAgentId })
      .subscribe({
        next: (response) => {
          this.bonusBalanceData = response.data.bonusBalance;
        },
        error: () => {
          this._toastrSvc.error('Internal server error', 'Error');
        },
      });
    this.subscriptions.push(subscription);
  }

  sendFormData() {
    this.isLoadingButton = true;

    const formData = {
      ...this.bonusForm.value,
      id_usu_creabono: this.id_agente,
      detalle_tipo_bono: this.selectedOption?.detalle,
      id_pais: this.id_country,
      id_tipo_bono: this.selectedOption?.value,
    };
    const fractions = formData.fracciones;
    const totalAmount =
      parseFloat(this.bonusForm.get('monto')?.value || '0') * fractions;

    if (this.idRol === this.agente && totalAmount > this.bonusBalanceData) {
      this.isLoadingButton = false;
      this._toastrSvc.error(
        'Saldo insuficiente para crear los bonos, Recargue',
        'Error'
      );
      return;
    }

    const request = {
      data: formData,
      fracciones: fractions,
    };

    this.bonusCodeService.createCodeBonus(request).subscribe(
      () => {
        this.isLoadingButton = false;
        this._toastrSvc.success('Bonos creados con éxito!', '');
        this.dynamicModal.notifyBonusCreated();
        this.closeModal();
      },
      () => {
        this.isLoadingButton = false;
        this._toastrSvc.error('Error al crear los bonos', '');
      }
    );
  }

  onInputChange(event: any) {
    let value = Math.round(event.target.value);
    if (value < 0) {
      value = 0;
    }
    event.target.value = value;
    this.bonusForm.patchValue({ fracciones: value });
    this.calculateResultAmountBonus();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
